import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faDownload, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/authContext";
import qs from "qs";
import { API_BASE_URL, API_KEY } from "../../../config/config";
import axios from "axios";

const Buttons = ({ video, isVertical = false, onOpenCommentList = null }) => {
	const { visitor } = useContext(AuthContext);

	const [isVideoReacted, setIsVideoReacted] = useState(false);

	const [videoData, setVideoData] = useState({
		reaction_score: 0,
		reply_count: 0,
	});

	const reactToVideo = async (video) => {
		if (!visitor || !video) return;

		try {
			const data = qs.stringify({ reaction_id: 1 });
			const config = {
				method: "post",
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/posts/${video.post_id}/react`,
				headers: {
					"XF-Api-Key": API_KEY,
					"XF-Api-User": visitor.user_id,
					"Content-Type": "application/x-www-form-urlencoded",
				},
				data: data,
				withCredentials: true,
			};

			const response = await axios.request(config);
			const action = response.data.action;

			if (action === "insert") {
				setIsVideoReacted(true);
				setVideoData((prevData) => ({
					...prevData,
					reaction_score: prevData.reaction_score + 1,
				}));
			} else {
				setIsVideoReacted(false);
				setVideoData((prevData) => ({
					...prevData,
					reaction_score: Math.max(prevData.reaction_score - 1, 0),
				}));
			}
		} catch (error) {
			console.error("Failed to react:", error);
		}
	};

	const handleReactToVideo = () => {
		reactToVideo(video);
	};

	useEffect(() => {
		if (video && video.Post.is_reacted) {
			setIsVideoReacted(true);
		}

		setVideoData((prevData) => ({
			...prevData,
			reaction_score: video.Post.reaction_score,
			reply_count: video.Thread.reply_count,
		}));
	}, [video, setIsVideoReacted]);

	if (videoData) {
		return (
			<div className={`flex ${isVertical ? "flex-col justify-center gap-y-4 text-xs" : "items-center gap-x-4"} text-white font-bold`}>
				<button onClick={handleReactToVideo} className={`inline-flex ${isVertical ? 'flex-col' : 'gap-x-2'} items-center ${isVideoReacted ? "text-yellow-500" : ""}`}>
					<FontAwesomeIcon icon={faThumbsUp} className="text-xl" />
					<span className={`${isVertical ? '' : 'text-xs'}`}>{videoData.reaction_score}</span>
				</button>

				{onOpenCommentList !== null
					? (
						<button onClick={onOpenCommentList} className={`inline-flex ${isVertical ? 'flex-col' : 'gap-x-2'} items-center`}>
							<FontAwesomeIcon icon={faComments} className="text-xl"/>
							<span className={`${isVertical ? '' : 'text-xs'}`}>{videoData.reply_count}</span>
						</button>
					) : (
						<a href={`${video.view_url}`} className={`inline-flex ${isVertical ? 'flex-col' : 'gap-x-2'} items-center`}>
							<FontAwesomeIcon icon={faComments} className="text-xl"/>
							<span className={`${isVertical ? '' : 'text-xs'}`}>{videoData.reply_count}</span>
						</a>
					)
				}

				<a href={`${video.Attachment.view_url}download`} className={`inline-flex ${isVertical ? 'flex-col' : 'gap-x-2'} items-center`}>
					<FontAwesomeIcon icon={faDownload} className="text-xl"/>
					<span className={`${isVertical ? '' : 'text-xs'}`}>{video.Attachment.view_count}</span>
				</a>
			</div>
		);
	}

	return null;
};

const VideoItemActionButtons = ({ video, isVertical = false, onOpenCommentList = null }) => {
	return (
		<Buttons video={video} isVertical={isVertical} onOpenCommentList={onOpenCommentList} />
	);
};

export default VideoItemActionButtons;